module.exports = __webpack_public_path__ + "img/1588796865.1a42035b.jpg";